import { render, staticRenderFns } from "./GraficosSection.vue?vue&type=template&id=bafda006&scoped=true&"
import script from "./GraficosSection.vue?vue&type=script&lang=js&"
export * from "./GraficosSection.vue?vue&type=script&lang=js&"
import style0 from "./GraficosSection.vue?vue&type=style&index=0&id=bafda006&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafda006",
  null
  
)

export default component.exports